/* eslint-disable react/no-unescaped-entities */
import Head from "next/head";
import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import * as Toast from "@radix-ui/react-toast";
import {
  doc,
  getDoc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  fetchSignInMethodsForEmail,
  EmailAuthProvider,
  sendSignInLinkToEmail,
} from "firebase/auth";
import { AnimatePresence, motion } from "framer-motion";
import { authError } from "../utils/errors/authError";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FiEye, FiEyeOff } from "react-icons/fi";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { load } from "@fingerprintjs/botd";
import { dbAdmin } from "../lib/firebase-admin";
import {
  IoAnalyticsOutline,
  IoFootstepsOutline,
  IoMailUnreadOutline,
  IoPeopleOutline,
  IoWalletOutline,
} from "react-icons/io5";
import Image from "next/image";
import { GoChecklist } from "react-icons/go";
import nookies from "nookies";
import cookie from "js-cookie";
import * as Sentry from "@sentry/browser";

import { getUrl } from "../utils/getUrl";
import { addGroup, capture, identify } from "../utils/analytics/capture";

export async function getServerSideProps(context, query) {
  const { code } = context.query;
  let cookiesPresent = context.req.cookies;
  // console.log(cookiesPresent.code)
  if (cookiesPresent.code) {
    nookies.set(undefined, "code", cookiesPresent.code, {
      maxAge: 365 * 24 * 60 * 60 * 1000,
      path: "/",
    });
  }
  if (cookiesPresent.fast_auth === "true" && cookiesPresent.session) {
    let user;

    const manager = cookiesPresent.manager;

    const uid = cookiesPresent.tag;

    // try {
    //   user = await authAdmin.verifyIdToken(cookiesPresent.session);
    // } catch (error) {
    //   console.log(error);
    // }

    // console.log(manager);

    if (manager === "false") {
      return {
        props: {},
      };
    }
    // console.log(user);

    // if ( user.manager && user.accessLevel === 0) {
    // return {
    //   redirect: {
    //     destination: "/lister/dashboard",
    //     permanent: true,
    //   },
    // };
    // }
    if (manager === "true") {
      const listerData = await dbAdmin.collection("Listers").doc(uid).get();
      if (!listerData.data()?.onboardingComplete) {
        return {
          redirect: {
            destination: "/lister/onboarding",
            permanent: true,
          },
        };
      }

      // return {
      //   props: {
      //     // user: JSON.stringify(listerData.data().auth),
      //     data: JSON.stringify(listerData.data()),
      //   },
      // };
      return {
        redirect: {
          destination: "/lister/dashboard",
          permanent: true,
        },
      };
    }
    return {
      props: {},
    };
  } else {
    return {
      props: {},
    };
  }
}

function HodariAgent() {
  // console.log(props)
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetPassword, setResetPassword] = useState(false);
  const [sendingResetLink, setSendingResetLink] = useState(false);
  const [resetLinkSent, setResetLinkSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendingLink, setSendingLink] = useState(false);
  const [linkSent, setLinkSent] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;
  const db = getFirestore();

  const [showPasswordField, setShowPasswordField] = useState(false);

  const [text, setText] = useState(null);

  const [passwordShown, setPasswordShown] = useState(false);

  const [open, setOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState(0);
  const signUpBodyRef = useRef(null);
  const emailInput = useRef(null);
  const functions = getFunctions();
  const checkUser = httpsCallable(functions, "checkUser");
  const addManagerRole = httpsCallable(functions, "addManagerClaim");

  const executeScroll = async () =>
    await signUpBodyRef?.current.scrollIntoView({
      behavior: "smooth",
    });
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      if (router.query?.new === "1") {
        setActiveTab(1);
      }
      if (router.query?.code?.length > 0) {
        cookie.set("code", router.query.code, {
          expires: 365,
        });
      }
      if (cookie.get("code")?.length > 0) {
        router.replace({
          query: { ...router.query, code: cookie.get("code") },
        });
      }

      isFirstRender.current = false;

      return;
    }

    return () => {};
  }, []);

  //
  const [bot, setBot] = useState(false);
  // const { executeRecaptcha } = useGoogleReCaptcha();
  // const handleRecaptcha = useCallback(() => {
  //   if (!executeRecaptcha) {
  //     console.log("Execute recaptcha not yet available");
  //     return;
  //   }
  //   executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
  //     fetch("/api/recap", {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json, text/plain, */*",
  //         "Content-Type": "application/json",
  //       },

  //       body: JSON.stringify({
  //         gRecaptchaToken: gReCaptchaToken,
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((resp) => {
  //         console.log(resp);
  //         if (resp?.status === "success") {
  //           console.log(resp?.message.score);
  //           console.log("success");
  //           if (!bot) {
  //             setBot(false);
  //           }
  //           return;
  //         } else {
  //           console.log(resp?.message);
  //           //console.log("no oerrd")
  //           setBot(true);
  //           return;
  //         }
  //       });
  //   });
  // }, [executeRecaptcha]);

  useEffect(() => {
    // if (executeRecaptcha) {
    load()
      .then((botd) => {
        return botd.detect();
      })
      .then((result) => {
        console.log(result.bot);
        setBot(result.bot);
        if (!result.bot) {
          // handleRecaptcha();
        }
      })
      .catch((error) => console.error(error));
    // }
    return () => {};
  }, []);

  const giveCode = () => {
    //abcdefghijklmnopqrstuvwxyz
    const DEFAULT_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let id;
    function getRandomCharFromAlphabet(alphabet) {
      return alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    function generateId(idDesiredLength, alphabet = DEFAULT_ALPHABET) {
      id = Array.from({ length: idDesiredLength })
        .map(() => {
          return getRandomCharFromAlphabet(alphabet);
        })
        .join("");
      return id;
    }
    const finalCode = generateId(6);
    return finalCode;
  };

  const createUser = async (email, password) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;
        await setDoc(doc(db, "Listers", user.uid), {
          auth: {
            email: user.email,
            emailVerified: user.emailVerified,
            isAnonymous: user.isAnonymous,
            photo: user.photoURL,
            phoneNumber: user.phoneNumber,
            displayName: user.displayName,
            accessToken: user.accessToken,
            providerData: user.providerData,
            uid: user.uid,
            createdTime: user.metadata.creationTime,
            lastSignInTime: user.metadata.lastSignInTime,
          },
          createdBy: "SELF",
          code: giveCode(),
          verification: {
            emailmatch: "PENDING",
            phonematch: "PENDING",
            credibilitychecks: "PENDING",
          },
          invited_by:
            cookie.get("code")?.length > 0 ? cookie.get("code") : null,
          onboardingComplete: false,
          listerVerified: false,
          onboardingPosition: 1,
          listerInfo: {
            listerType: "INDIVIDUAL_AGENT",
            canChangeUserName: true,
            listerCounty: {
              countyID: null,
              countyName: null,
            },
            listerTown: {
              townID: null,
              townName: null,
            },
            listerArea: {
              relative: false,
              descriptor: null,
              areaName: null,
              areaID: null,
            },
          },
          currentPlan: {
            plan: "FREE",
            expires: null,
            activatedDb: serverTimestamp(),
          },
          wallet: {
            amount: 0,
            lastTopUpTime: null,
            lastDeductedTime: null,
            lastDeductedAmount: null,
            lastPlanActivated: null,
          },
          listerSocial: {},
          propertyStats: {
            totalProperties: 0,
            propertiesForRent: 0,
            propertiesForSale: 0,
            activeProperties: 0,
            activeOffMarketProperties: 0,
            activePropertiesForRent: 0,
            activePropertiesForSale: 0,
            totalActiveProperties: 0,
          },
        }).catch((err) => {
          console.log(err);
        });
        setText("Setting up...");
        let res = await addManagerRole({
          uid: user.uid,
          property_owner: false,
        });
        setText("Final touches...");
        await user.getIdToken(true);
        const tokenResult = await auth.currentUser.getIdTokenResult(true);

        identify({
          id: user.uid,
          properties: {
            plan: "FREE",
            ula_uid: user.uid,
            email_verified: tokenResult.claims.email_verified,
            sign_in_provider_used: tokenResult.claims.firebase.sign_in_provider,
            manager: tokenResult.claims.manager
              ? tokenResult.claims.manager
              : false,
            normal_user: tokenResult.claims.user
              ? tokenResult.claims.user
              : false,
          },
        });

        capture({
          type: "lister",
          category: "auth",
          event: "signup",
        });
        if (tokenResult.claims.manager) {
          addGroup({
            type: "lister",
            id: user.uid,
            properties: {
              date_joined: user.metadata.creationTime,
            },
          });
        } else if (tokenResult.claims.user) {
        }

        capture({
          type: "lister",
          category: "auth",
          event: "onboarding_start",
        });
        cookie.remove("code");
        // End Mixpanel Input
        router.push("/lister/onboarding").then(() => {
          setLoading(false);
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        setError({ errorCode, errorMessage });
        setLoading(false);
        setOpen(true);
        if (errorCode === "auth/email-already-in-use") {
          setActiveTab(0);
          setShowPasswordField(false);
          return;
        }
      });
  };

  const signInLister = async (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;
        const tokenResult = await auth.currentUser.getIdTokenResult(true);
        // console.log(tokenResult.claims)
        if (tokenResult.claims.manager) {
          Sentry.setUser({ email: user.email, id: user.uid });
          // Mixpanel Input

          identify({
            id: user.uid,
            properties: {
              ula_uid: user.uid,
              email_verified: tokenResult.claims.email_verified,
              sign_in_provider_used:
                tokenResult.claims.firebase.sign_in_provider,
              manager: tokenResult.claims.manager
                ? tokenResult.claims.manager
                : false,
              normal_user: tokenResult.claims.user
                ? tokenResult.claims.user
                : false,
            },
          });

          capture({
            type: "lister",
            category: "auth",
            event: "signin",
          });
          if (tokenResult.claims.manager) {
            addGroup({
              type: "lister",
              id: user.uid,
              properties: {
                date_joined: user.metadata.creationTime,
              },
            });
          }
          // End Mixpanel Input
          const docRef = doc(db, "Listers", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            let userData = docSnap.data();
            if (userData.onboardingComplete) {
              // onboarding complete

              router.push("/lister/dashboard").then(() => {
                setLoading(false);
              });
            } else {
              // take to onboarding

              router.push("/lister/onboarding").then(() => {
                setLoading(false);
              });
            }
          } else {
            console.log("No such lister!");
          }
        } else if (tokenResult.claims.team_member) {
          // router.push("/lister/dashboard").then(()=>{
          //   setLoading(false);
          // });
          console.log("is team member");
        } else if (tokenResult.claims.user) {
          setLoading(false);
          Sentry.setUser({ email: user.email, id: user.uid });
          // Mixpanel Input

          identify({
            id: user.uid,
            properties: {
              ula_uid: user.uid,
              email_verified: tokenResult.claims.email_verified,
              sign_in_provider_used:
                tokenResult.claims.firebase.sign_in_provider,
              manager: tokenResult.claims.manager
                ? tokenResult.claims.manager
                : false,
              normal_user: tokenResult.claims.user
                ? tokenResult.claims.user
                : false,
            },
          });
          if (tokenResult.claims.manager) {
            addGroup({
              type: "lister",
              id: user.uid,
              properties: {
                date_joined: user.metadata.creationTime,
              },
            });
          } else if (tokenResult.claims.user) {
          }

          capture({
            type: "user",
            category: "auth",
            event: "signin",
          });
          // End Mixpanel Input
          setError({
            errorCode: "auth/account-already-exists-as-user",
            errorMessage: "Use a different email account to list a property",
          });
          setOpen(true);
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        setError({ errorCode, errorMessage });
        setLoading(false);
        if (errorCode === "auth/email-already-in-use") {
          setActiveTab(0);
          setShowPasswordField(false);
        }

        setOpen(true);
      });
  };
  const ogURL = `${getUrl()}/api/og/invite-og?code=${
    cookie.get("code")?.length > 0 ? cookie.get("code") : null
  }`;
  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>Join as an Agent - Zote</title>
        <meta
          name="description"
          content="Showcase your business to buyers and renters in your market.
          Find more leads, close deals and increase your sales"
        />
        <meta property="og:title" content={"Join as an Agent - Zote"} />
        <meta
          property="og:description"
          content={`Showcase your business to buyers and renters in your market.
          Find more leads, close deals and increase your sales`}
        />
        <meta property="og:url" content={`${getUrl()}/hodari`} />

        <link rel="canonical" href={`${getUrl()}/hodari`} />
        <meta property="og:image" content={`${ogURL}`} />
      </Head>
      <div className=" flex flex-col divide-y-0 divide-gray-200 overflow-y-auto ">
        <main className="  flex h-full flex-col lg:flex-row">
          <Toast.Provider swipeDirection="right">
            <Toast.Root
              duration={2800}
              className=" flex flex-row justify-between space-x-0 rounded-lg border  border-red-100 bg-red-100 px-6 py-4 shadow-lg"
              open={open}
              onOpenChange={() => {
                setOpen(false);
                setError(null);
              }}
            >
              <AnimatePresence>
                {open && (
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.7 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{
                      opacity: 0,
                      scale: 0.5,
                      transition: { duration: 0.6 },
                    }}
                    className="flex flex-row"
                  >
                    <div className=" flex flex-col space-y-0">
                      <Toast.Title className="  mb-0 text-base font-semibold text-red-600 ">
                        {authError(error.errorCode).title}
                      </Toast.Title>
                      <Toast.Description asChild>
                        <span className=" text-sm text-red-600">
                          {authError(error.errorCode).message}
                        </span>
                      </Toast.Description>
                    </div>
                    <Toast.Action altText="Close">
                      <button
                        onClick={() => {
                          setOpen(false);
                        }}
                        className=" invisible ml-8 rounded-md border  border-red-200 bg-transparent px-4 py-1 text-xs font-semibold text-black "
                      >
                        Close
                      </button>
                    </Toast.Action>
                    <Toast.Close />
                  </motion.div>
                )}
              </AnimatePresence>
            </Toast.Root>

            <Toast.Viewport className=" fixed bottom-0 right-0 mb-5 flex w-full max-w-screen-lg flex-col px-2 lg:mr-10 lg:w-auto lg:gap-10 lg:px-0" />
          </Toast.Provider>

          <div className=" flex w-full flex-col items-start  space-y-5 bg-zote-secondary px-8  pb-12 pt-6 lg:h-screen lg:w-3/5 lg:space-y-10 lg:px-32 lg:py-20">
            {/* <h1 className=" text-4xl font-bold text-zote-corn lg:text-7xl">
              Homes<br className="  hidden lg:flex"></br> showcased<br></br> to
              the right audience
            </h1> */}
            <h1 className=" text-4xl font-bold text-gray-300 lg:mt-5 lg:text-7xl ">
              Larger market.<br className=" hidden lg:flex  "></br> More reach.
              <br className="hidden lg:flex"></br> More sales.
            </h1>
            <h2 className=" mr-6 text-lg text-gray-200 lg:mr-40 lg:text-xl lg:text-gray-200">
              Showcase your business to buyers and renters in your market.
              <br className=" flex"></br> Focus on what matters most, connecting
              and selling to prospective buyers and renters
            </h2>
          </div>
          {!resetPassword ? (
            <form
              onSubmit={
                loading
                  ? () => {}
                  : async (e) => {
                      e.preventDefault();

                      if (activeTab === 0) {
                        setLoading(true);

                        if (email && password && showPasswordField) {
                          await signInLister(email, password);
                          return;
                        }

                        fetchSignInMethodsForEmail(auth, email)
                          .then(async (signInMethods) => {
                            // console.log(signInMethods);
                            // This returns the same array as fetchProvidersForEmail but for email
                            // provider identified by 'password' string, signInMethods would contain 2
                            // different strings:
                            // 'emailLink' if the user previously signed in with an email/link
                            // 'password' if the user has a password.
                            // A user could have both.
                            if (
                              signInMethods.indexOf(
                                EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
                              ) != -1
                            ) {
                              setShowPasswordField(true);
                              setLoading(false);
                              return;
                              // User can sign in with email/password.
                            }
                            if (
                              signInMethods.indexOf(
                                EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD
                              ) != -1 ||
                              signInMethods.length === 0
                            ) {
                              const actionCodeSettings = {
                                // URL you want to redirect back to. The domain (www.example.com) for this
                                // URL must be in the authorized domains list in the Firebase Console.
                                url: `https://zote.africa/hodari?actionId=onboarding`,
                                // This must be true.
                                handleCodeInApp: true,
                                // iOS: {
                                //   bundleId: "com.ulaafrica.app",
                                // },
                                // android: {
                                //   packageName: "com.ulaafrica.app",
                                //   installApp: true,
                                //   minimumVersion: "12",
                                // },
                                dynamicLinkDomain:
                                  process.env.NODE_ENV === "development" ||
                                  process.env.NEXT_PUBLIC_VERCEL_ENV ===
                                    "preview"
                                    ? "staging-api.ula.africa"
                                    : "link.ula.africa",
                              };

                              let res = await checkUser({ email });
                              // console.log(res.data.message.ifUser);
                              if (!res.data.message.ifUser) {
                                setActiveTab(1);
                                setLoading(false);
                                return;
                              }
                              if (!res.data.message.claim.manager) {
                                setLoading(false);
                                return;
                              }
                              sendSignInLinkToEmail(
                                auth,
                                email,
                                actionCodeSettings
                              )
                                .then(() => {
                                  // The link was successfully sent. Inform the user.
                                  // Save the email locally so you don't need to ask the user for it again
                                  // if they open the link on the same device.
                                  setLoading(false);
                                  setSendingLink(false);
                                  setLinkSent(true);
                                  window.localStorage.setItem(
                                    "emailForSignIn",
                                    email
                                  );
                                  // ...
                                })
                                .catch((error) => {
                                  const errorCode = error.code;
                                  const errorMessage = error.message;
                                  // ...
                                });
                              // User can sign in with email/link.
                            }
                          })
                          .catch((error) => {
                            // Some error occurred, you can inspect the code: error.code
                          });
                        // sign in user
                      } else {
                        setLoading(true);
                        fetchSignInMethodsForEmail(auth, email)
                          .then(async (signInMethods) => {
                            // console.log(signInMethods)
                            // This returns the same array as fetchProvidersForEmail but for email
                            // provider identified by 'password' string, signInMethods would contain 2
                            // different strings:
                            // 'emailLink' if the user previously signed in with an email/link
                            // 'password' if the user has a password.
                            // A user could have both.
                            if (
                              signInMethods.indexOf(
                                EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
                              ) != -1 ||
                              signInMethods.length === 0
                            ) {
                              // User can sign in with email/password.
                              setText("Creating account...");
                              // create the user
                              try {
                                await createUser(email, password);
                              } catch (error) {
                                // setActiveTab(0);
                                // console.log(error);
                              }
                            }
                            if (
                              signInMethods.indexOf(
                                EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD
                              ) != -1
                            ) {
                              const actionCodeSettings = {
                                // URL you want to redirect back to. The domain (www.example.com) for this
                                // URL must be in the authorized domains list in the Firebase Console.
                                url: `https://ula.africa/hodari?actionId=onboarding`,
                                // This must be true.
                                handleCodeInApp: true,
                                // iOS: {
                                //   bundleId: "com.ulaafrica.app",
                                // },
                                // android: {
                                //   packageName: "com.ulaafrica.app",
                                //   installApp: true,
                                //   minimumVersion: "12",
                                // },
                                dynamicLinkDomain:
                                  process.env.NODE_ENV === "development" ||
                                  process.env.NEXT_PUBLIC_VERCEL_ENV ===
                                    "preview"
                                    ? "staging-api.ula.africa"
                                    : "link.ula.africa",
                              };
                              sendSignInLinkToEmail(
                                auth,
                                email,
                                actionCodeSettings
                              )
                                .then(() => {
                                  // The link was successfully sent. Inform the user.
                                  // Save the email locally so you don't need to ask the user for it again
                                  // if they open the link on the same device.
                                  setLoading(false);
                                  setSendingLink(false);
                                  setLinkSent(true);
                                  window.localStorage.setItem(
                                    "emailForSignIn",
                                    email
                                  );
                                  // ...
                                })
                                .catch((error) => {
                                  const errorCode = error.code;
                                  const errorMessage = error.message;
                                  console.log(errorCode);
                                  // ...
                                });
                              // User can sign in with email/link.
                            }
                          })
                          .catch((error) => {
                            // Some error occurred, you can inspect the code: error.code
                            console.log(error);
                          });
                      }
                    }
              }
              className=" flex h-[60vh] w-full  flex-col  justify-center space-y-4 px-8 py-8  lg:h-full lg:w-2/5 lg:justify-normal lg:py-32 lg:pl-24"
              ref={signUpBodyRef}
            >
              <div className=" flex flex-col space-y-3">
                <div className=" flex flex-row items-end space-x-5">
                  <h3
                    onClick={() => {
                      if (!loading) {
                        setActiveTab(0);
                      }
                    }}
                    className={
                      "  cursor-pointer underline " +
                      (activeTab === 0
                        ? "  text-xl font-semibold underline decoration-zote-primary decoration-2 underline-offset-8  lg:text-xl "
                        : " text-lg text-gray-700 decoration-transparent")
                    }
                  >
                    Login
                  </h3>
                  <h3
                    onClick={() => {
                      if (!loading) {
                        setActiveTab(1);
                      }
                    }}
                    className={
                      "  cursor-pointer underline " +
                      (activeTab === 1
                        ? "  text-xl font-semibold  decoration-zote-primary decoration-2 underline-offset-8  lg:text-xl "
                        : " text-lg text-gray-700 decoration-transparent ")
                    }
                  >
                    Create agent profile
                  </h3>
                </div>
                {activeTab === 0 ? (
                  <span className=" cursor-default select-none text-base text-gray-600">
                    Welcome back
                  </span>
                ) : (
                  <span className=" cursor-default select-none text-base text-gray-600">
                    Grow your real estate business and brand
                  </span>
                )}
              </div>

              {linkSent ? (
                <div className="  flex w-3/4 flex-col justify-center lg:w-2/3 lg:items-center">
                  <div className=" mb-4 mt-5 flex h-24 w-24 items-center justify-center rounded-full bg-blue-100">
                    <IoMailUnreadOutline className="  h-8 w-8 " />
                  </div>
                  <h1 className="text-xl font-semibold lg:text-center ">
                    Sign in link sent to {email}
                  </h1>
                  <span className=" text-left text-gray-700">
                    Check your mail app
                  </span>
                </div>
              ) : null}

              {!linkSent ? (
                <div className=" flex flex-col space-y-5">
                  <div className="flex flex-col space-y-1">
                    <label className="font-medium">Email</label>
                    <input
                      ref={emailInput}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                      disabled={bot}
                      placeholder="Enter Email"
                      type="email"
                      className=" w-full rounded-md border border-gray-400 bg-gray-100  px-4 py-3 focus:border-zote-primary disabled:cursor-not-allowed disabled:bg-gray-200 lg:w-4/5"
                      required
                    ></input>
                  </div>

                  {showPasswordField || activeTab == 1 ? (
                    <div className="flex flex-col space-y-1">
                      <div className="flex flex-row justify-between lg:w-4/5">
                        <label className=" font-medium">Password</label>
                        <div
                          onClick={() => {
                            setPasswordShown(!passwordShown);
                          }}
                          className="group flex cursor-pointer flex-row items-center space-x-2"
                        >
                          {!passwordShown ? (
                            <FiEye className=" text-gray-700 group-hover:text-gray-700" />
                          ) : (
                            <FiEyeOff className="text-gray-700 group-hover:text-gray-700" />
                          )}
                          {passwordShown ? (
                            <span className=" text-sm text-gray-700 group-hover:text-gray-700">
                              Hide
                            </span>
                          ) : (
                            <span className=" text-sm text-gray-700 group-hover:text-gray-700">
                              Show
                            </span>
                          )}
                        </div>
                      </div>
                      <input
                        value={password}
                        placeholder="Password"
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        disabled={bot}
                        type={passwordShown ? "text" : "password"}
                        className=" w-full rounded-md border border-gray-400 bg-gray-100 px-4 py-3 focus:border-zote-primary disabled:cursor-not-allowed disabled:bg-gray-200 lg:w-4/5"
                        required
                      ></input>
                      {activeTab === 0 ? (
                        <span
                          onClick={() => {
                            setResetPassword(true);
                          }}
                          className=" cursor-pointer text-sm text-gray-700 hover:underline"
                        >
                          Forgot password
                        </span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}

              {!linkSent ? (
                <div className=" flex flex-col space-y-2 pt-1">
                  {!loading || bot ? (
                    <button
                      disabled={bot}
                      type={bot ? "button" : "submit"}
                      className=" w-full rounded-md bg-zote-primary px-6 py-4 font-semibold text-white disabled:cursor-not-allowed disabled:bg-blue-400 lg:w-4/5"
                    >
                      {activeTab === 0 ? "Continue" : "Create account"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className=" flex  w-full flex-row items-center justify-center space-x-4 rounded-md bg-zote-primary px-6 py-4 text-white lg:w-4/5"
                    >
                      <AiOutlineLoading3Quarters className="my-1 h-4 w-4 animate-spin" />
                      {activeTab === 1 ? (
                        <span className=" text-base">{text}</span>
                      ) : null}
                      {/* <span className=" text-base">Setting up...</span> */}
                      {/* <span className=" text-base">Almost there...</span> */}
                      {/* <span className=" text-base">Final touches...</span> */}

                      {/* <span className=" text-base">Preparing account...</span> */}
                      {/* <span className=" text-base">Setting up...</span> */}
                      {/* <span className=" text-base">Final touches...</span> */}
                    </button>
                  )}
                </div>
              ) : null}

              {/* <div className=" w-4/5 h-1 bg-gray-700  text-xs"></div>

          <button type="button" className=" hover:bg-gray-100 rounded-md w-4/5 py-3 border border-gray-600 flex flex-row justify-center items-center">
            <span className=" mr-4 text-lg">G</span> Continue with Google
          </button> */}
            </form>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setSendingResetLink(true);
                var actionCodeSettings = {
                  url: getUrl() + "/hodari",
                };

                sendPasswordResetEmail(auth, email, actionCodeSettings)
                  .then(() => {
                    setSendingResetLink(false);
                    setResetLinkSent(true);
                  })
                  .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    //   console.log(errorCode);
                    //authError(errorCode, errorMessage);
                    setError({ errorCode, errorMessage });
                    setOpen(true);
                    setSendingResetLink(false);
                    setResetLinkSent(false);
                  });
              }}
              className=" flex h-full  w-full  flex-col space-y-4  px-8 py-8 lg:w-2/5 lg:py-32 lg:pl-24"
              ref={signUpBodyRef}
            >
              {resetLinkSent ? (
                <div className=" flex flex-col space-y-1">
                  <h2 className="text-xl font-medium">
                    Forgot password link sent
                  </h2>
                  <span className=" text-sm">Check your mail app</span>
                </div>
              ) : (
                <div className=" flex flex-col space-y-1">
                  <h2 className="text-xl font-medium">Reset your password</h2>
                  <span className=" text-sm">
                    We'll email you instructions to reset your password.
                  </span>
                </div>
              )}
              <fieldset className=" mb-1 flex flex-col space-y-1">
                <label className=" font-medium text-gray-700">Email</label>
                <input
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                  autoFocus={false}
                  type="email"
                  disabled={resetLinkSent || bot}
                  placeholder="Email"
                  className=" w-full rounded-md border border-gray-400 bg-gray-100 px-4 py-3 placeholder-gray-400 focus:border-zote-primary lg:w-4/5"
                  required
                ></input>
              </fieldset>
              {sendingResetLink ? (
                <button
                  type="button"
                  className=" flex items-center justify-center rounded-md bg-zote-primary py-4 font-medium text-zinc-100 lg:w-4/5"
                >
                  <AiOutlineLoading3Quarters className="h-4 w-4 animate-spin" />
                </button>
              ) : (
                <>
                  {resetLinkSent ? (
                    <>
                      <button
                        type="button"
                        className=" flex flex-row items-center justify-center space-x-2 rounded-md bg-green-600 py-3 font-semibold text-zinc-50 lg:w-4/5"
                      >
                        <MdOutlineMarkEmailRead className=" h-5 w-5" />
                        <span>Sent</span>
                      </button>
                      <div className=" flex items-center justify-center  lg:w-4/5">
                        <span
                          className="w-auto cursor-pointer  text-center text-sm hover:underline"
                          onClick={() => {
                            setResetPassword(false);
                          }}
                        >
                          Signin
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <button
                        type="submit"
                        className="  rounded-md bg-zote-primary py-3 font-medium text-zinc-50 lg:w-4/5"
                      >
                        Send link
                      </button>
                      <div className=" flex items-center justify-center  lg:w-4/5">
                        <span
                          className="w-auto cursor-pointer  text-center text-sm hover:underline"
                          onClick={() => {
                            setResetPassword(false);
                          }}
                        >
                          Cancel
                        </span>
                      </div>
                    </>
                  )}
                </>
              )}
            </form>
          )}
        </main>
        <div className=" flex flex-col justify-center  space-y-10 bg-zote-background py-20 lg:flex-row lg:space-x-24 lg:space-y-0 lg:py-32">
          <div className="flex flex-col items-center space-y-1 lg:space-y-2">
            <span className="  text-4xl font-bold lg:text-5xl">300+</span>
            <span className=" text-base ">Daily searches</span>
          </div>
          <div className="flex flex-col items-center space-y-1 lg:space-y-2">
            <span className="  text-4xl font-bold lg:text-5xl">52</span>
            <span className=" text-base ">Average Property Days on Market</span>
          </div>
          <div className="flex flex-col items-center space-y-1 lg:space-y-2">
            <span className="  text-4xl font-bold lg:text-5xl">10,000+</span>
            <span className=" text-base ">Monthly Page Views</span>
          </div>
          <div className="flex flex-col items-center space-y-1 lg:space-y-2">
            <span className="  text-4xl font-bold lg:text-5xl">80%</span>
            <span className=" text-base ">Kenya Traffic</span>
          </div>
          <div className="flex flex-col items-center space-y-1 lg:space-y-2">
            <span
              title="United States, Middle East and Africa Traffic"
              className="  text-4xl font-bold lg:text-5xl"
            >
              14%
            </span>
            <span
              title="United States, Middle East and Africa Traffic"
              className=" text-base "
            >
              US, MEA Traffic
            </span>
          </div>
        </div>

        <div className=" flex flex-col bg-zote-secondary text-gray-100 lg:flex-row lg:bg-[#0D242A] lg:text-gray-900">
          <div className=" order-2 flex flex-col space-y-2 px-8 pb-20 pt-12  text-gray-300 lg:order-1 lg:w-[45%]  lg:space-y-5  lg:px-24 lg:py-40">
            <h2 className=" text-3xl font-semibold  lg:text-6xl  ">
              The platform for the modern<br className=" hidden lg:flex"></br>{" "}
              real estate team
            </h2>
            <span className="lg:text-xl">
              Innovative real estate professionals and companies use Hodari to
              create and build business presence.{" "}
            </span>
          </div>
          <div className=" order-1 w-full  pr-0 lg:order-2 lg:w-[55%] lg:pl-5">
            <div className=" relative h-56 lg:h-full">
              <Image
                src="https://images.pexels.com/photos/3894377/pexels-photo-3894377.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                layout="fill"
                priority
                unoptimized
                className=" h-full w-full object-cover brightness-90"
                alt="Hodari Agent - Zote"
              />
            </div>
          </div>
        </div>
        <div className=" flex flex-col items-center space-y-12 bg-gray-100 py-20 lg:space-y-16 lg:bg-white lg:pb-48 lg:pt-40 ">
          <div className=" flex flex-col items-center space-y-3">
            <h2 className=" text-3xl font-semibold lg:text-5xl">
              What you get with Zote{" "}
              {/* <span className=" font-bold text-zote-primary">
              The Zote Advantage
            </span> */}
            </h2>
            <span className=" px-12 text-center text-base text-gray-700 lg:px-0">
              A variety of features that make it the platform to build your
              business presence
            </span>
          </div>
          <div className=" flex w-full flex-col items-center space-y-12 px-8 lg:flex-row lg:items-start lg:justify-between lg:space-y-0 lg:px-32">
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoWalletOutline className=" h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className=" text-lg font-semibold lg:text-2xl">
                  Qualified leads
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Increased buyer intention. 75% of visitors on zote are already
                  looking to buy and rent
                </span>
              </div>
            </div>
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoPeopleOutline className="h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className="text-lg font-semibold lg:text-2xl">
                  Wider audience
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Reach more, sell more. Put your properties in front of
                  thousands of prospective buyers and renters
                </span>
              </div>
            </div>
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoAnalyticsOutline className=" h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className=" text-lg font-semibold lg:text-2xl">
                  Market insights
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Meaningful insights. Get insightful analytics on the market
                  and performance of your properties
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="  flex flex-col bg-[#EBF4F5] lg:h-[70vh]  lg:flex-row lg:bg-[#EBF4F5] ">
          <div className=" flex h-full flex-col justify-center space-y-2 px-8 pb-8 pt-16  lg:w-[55%] lg:space-y-3 lg:px-32 lg:py-16">
            <h2 className=" text-2xl font-semibold lg:text-5xl">
              Market insights
            </h2>
            <span className=" lg:text-lg">
              Track key property metrics. <br></br> Optimize your sales strategy
              based on<br></br> how buyers and renters engage with your listings
            </span>
          </div>
          <div className="  relative flex h-full  w-full items-center justify-center  px-8 pb-16 lg:w-[45%] lg:px-0 lg:pb-0 lg:pr-20">
            <div className=" absolute bottom-48 left-12  z-10 h-[3.6rem] w-32 rounded-md lg:left-20">
              <Image
                className="absolute h-full w-full rounded-md object-cover"
                src="/image/analytics/leads.png"
                layout="fill"
                unoptimized
                alt="Hodari Lead Analytics"
              />
            </div>
            <div className=" absolute left-40 top-40 z-10 h-[3.6rem] w-32 rounded-md lg:left-56 lg:top-48">
              <Image
                className="absolute h-full w-full rounded-md object-cover"
                src="/image/analytics/impressions.png"
                layout="fill"
                unoptimized
                alt="Hodari Impression Analytics"
              />
            </div>
            <div className=" absolute  bottom-56 right-20 z-10 h-[3.5rem] w-32 rounded-md lg:bottom-40 lg:right-56">
              <Image
                className="absolute h-full w-full rounded-md object-cover"
                src="/image/analytics/views.png"
                unoptimized
                layout="fill"
                alt="Hodari Property Views Analytics"
              />
            </div>
            <div className=" relative h-64 w-full rounded-md lg:w-80  ">
              <Image
                className="absolute h-full w-full rounded-md object-cover"
                src="/image/bedroom-shot.jpeg"
                layout="fill"
                unoptimized
                alt="Hodari Property Analytics"
              />
            </div>
          </div>
        </div>

        <div className="  flex flex-col bg-white  lg:h-[90vh]  lg:flex-row ">
          <div className=" relative order-2 flex h-full  items-center justify-center px-8 py-0 pb-16 lg:order-1 lg:w-[45%] lg:px-0 lg:py-10 ">
            {/* <div className=" absolute bottom-16 right-40  z-10  h-8 w-48 rounded-md bg-transparent px-10 lg:bottom-20 lg:right-48">
              <Image
                className="absolute h-full w-full rounded-md bg-transparent object-contain lg:object-cover"
                src="/image/schedule-blue.png"
                layout="fill"
              />
            </div> */}
            <div className=" relative h-104 w-full rounded-md lg:h-[30rem] lg:w-80  ">
              <Image
                className="absolute h-full w-full rounded-md object-contain lg:object-cover"
                src="/image/message.gif"
                layout="fill"
                unoptimized
                alt="Hodari Message Send Exchange"
              />
            </div>
          </div>

          <div className=" order-1 flex h-full flex-col justify-start space-y-2 px-8 pb-8 pt-16  lg:w-[55%] lg:space-y-3 lg:px-32 lg:py-16  lg:pt-48">
            <h2 className=" text-2xl font-semibold  lg:text-5xl">
              Focus on selling
            </h2>
            <span className=" lg:text-lg">
              Boost your sales with Whatsapp leads and In-app messaging.
              <br></br> Get instant leads from interested buyers and tenants{" "}
              <br></br> in your inbox.
            </span>
          </div>
        </div>

        <div className="  flex flex-col  bg-[#EBF4F5] lg:h-[80vh] lg:flex-row ">
          <div className=" flex h-full w-full flex-col justify-center space-y-2 px-8 pb-8 pt-16  lg:w-[55%] lg:space-y-5 lg:px-32 lg:py-16">
            <h2 className=" text-2xl font-semibold lg:text-5xl">
              Upgrade your<br className=" hidden lg:flex"></br> online market{" "}
              <br></br> presence
            </h2>
            <span className=" lg:text-lg">
              Let buyers and renters find your business easily. <br></br> Your
              website, social media profiles <br></br> and contacts are all on
              Zote
            </span>
          </div>
          <div className="  relative flex h-full  w-full items-center justify-center  px-8 pb-16 lg:w-[45%] lg:px-0 lg:pb-0 lg:pr-20">
            <div className=" absolute z-10 h-[8.6rem] w-48 rounded-md bg-transparent px-10 lg:bottom-48">
              <Image
                className="absolute h-full w-full rounded-md bg-transparent object-cover"
                src="/image/contact.png"
                layout="fill"
                alt="Hodari Leads"
                unoptimized
              />
            </div>
            <div className=" absolute  left-72 top-6 z-10 h-6 w-6  rounded-md bg-transparent px-10 lg:bottom-48 lg:left-[28rem] lg:top-64 lg:h-8 lg:w-8">
              <Image
                className="absolute h-full w-full rounded-md bg-transparent object-contain"
                src="/image/ig.png"
                layout="fill"
                unoptimized
                alt="Hodari Lead Analytics"
              />
            </div>
            <div className=" absolute left-80 top-40 z-10 h-10 w-10 rounded-md bg-transparent px-10 lg:left-72">
              <Image
                className="absolute h-full w-full rounded-md bg-transparent object-contain"
                src="/image/reels.png"
                layout="fill"
                unoptimized
                alt="Hodari Social Media"
              />
            </div>
            <div className=" absolute left-[21rem] top-20 z-10 h-10 w-10 rounded-md bg-transparent px-10 lg:left-80">
              <Image
                className="absolute h-full w-full -rotate-6 rounded-md bg-transparent object-contain"
                src="/image/like.png"
                layout="fill"
                unoptimized
                alt="Hodari Social Media_2"
              />
            </div>
            <div className=" relative h-64 w-full rounded-md lg:w-80  ">
              <Image
                className="absolute h-full w-full rounded-md object-cover"
                src="/image/blue-apartment.jpeg"
                layout="fill"
                unoptimized
                alt="Hodari Property Blue Apartment"
              />
            </div>
          </div>
        </div>

        <div className=" flex h-auto w-full flex-col lg:flex-row">
          <div className=" relative h-80 w-full bg-gray-200 lg:h-auto lg:w-[50%]">
            <Image
              className=" h-full w-full object-cover  "
              layout="fill"
              unoptimized
              alt="Hodari Getting Started"
              src="https://images.pexels.com/photos/3894378/pexels-photo-3894378.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />
          </div>
          <div className=" flex w-full flex-col space-y-10 bg-white px-8 py-12 lg:w-[55%] lg:px-32 lg:py-24">
            <span className=" text-3xl font-bold  text-gray-900 lg:text-5xl">
              How it works
            </span>
            <div className=" flex flex-col lg:space-y-5">
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className=" flex h-12  w-12 items-center justify-center rounded-full  bg-lightblue-400 lg:h-16  lg:w-16">
                  <MdOutlineMarkEmailRead className=" h-5 w-5 text-gray-800 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">
                    Register your account
                  </h3>
                  <span className=" text-gray-600">
                    Provide an email and password for your account. Takes less
                    than a minute.
                  </span>
                </div>
              </div>
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className="  flex h-12 w-12 items-center justify-center rounded-full bg-lightblue-400 lg:h-16 lg:w-16">
                  <IoFootstepsOutline className=" h-5 w-5 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">
                    Complete onboarding
                  </h3>
                  <span className=" text-gray-600">
                    Provide public profile information about your company and
                    verify contact details.
                  </span>
                </div>
              </div>
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className="  flex h-12 w-12 items-center justify-center rounded-full bg-lightblue-400 lg:h-16 lg:w-16">
                  <GoChecklist className=" h-5 w-5 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">
                    Start listing your properties
                  </h3>
                  <span className=" w-full text-gray-600">
                    Add your properties and reach thousands of prospective
                    buyers and renters.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" px-5 py-12 lg:px-0 lg:py-0">
          <div className=" flex flex-col items-center justify-center space-y-6 rounded-md bg-zote-secondary  py-10  lg:h-[65vh] lg:space-y-8 lg:rounded-none lg:py-32">
            <div className=" flex flex-col items-center justify-center space-y-4 lg:space-y-5">
              <h2 className=" text-2xl font-bold  text-gray-200 lg:text-5xl">
                Create your agent profile
              </h2>
              <h3 className="  px-10 text-center text-base text-gray-200 lg:px-0 lg:text-lg">
                Get your real estate business to a larger more refined market.
                <br></br> Find more leads, close deals and increase your sales
                <br className=" hidden lg:flex"></br>
                {/* Lessen the marketing work
              and increase your sales */}
              </h3>
            </div>
            <div className="">
              <button
                onClick={async () => {
                  await executeScroll();
                  setActiveTab(1);
                  setTimeout(() => {
                    emailInput.current.focus();
                  }, 900);
                }}
                className=" w-auto rounded-md bg-zote-primary px-20 py-4  font-semibold text-white"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HodariAgent;
